// extracted by mini-css-extract-plugin
export default {"closebutton":"AddNewGoal_closebutton__yUh2E"};